import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Importa todas tus imágenes directamente aquí
import palma_1 from '../images/Flores/palma_1.avif';
import palma_2 from '../images/Flores/palma_2.avif';
import palma_3 from '../images/Flores/palma_3.avif';
import homenaje_1 from '../images/Flores/homenaje_1.avif';
import homenaje_2 from '../images/Flores/homenaje_2.avif';
import homenaje_3 from '../images/Flores/homenaje_3.avif';
import jarron_1 from '../images/Flores/jarron_1.avif';
import jarron_2 from '../images/Flores/jarron_2.avif';


const fotos = {
  naturales: [
    { id: 'palma1', name: 'palma1', src: palma_1, price: 120 },
    { id: 'palma2', name: 'palma2', src: palma_2, price: 150 },
    { id: 'palma3', name: 'palma3', src: palma_3, price: 180 },
    { id: 'homenaje1', name: 'homenaje1', src: homenaje_1, price: 90 },
    { id: 'homenaje2', name: 'homenaje2', src: homenaje_2, price: 110 },
    { id: 'homenaje3', name: 'homenaje3', src: homenaje_3, price: 130 },
    { id: 'jarron1', name: 'jarron1', src: jarron_1, price: 50 },
    { id: 'jarron2', name: 'jarron2', src: jarron_2, price: 65 },
  ],
  artificiales: []
};

const cleaningService = { id: 'cleaning_basic', name: 'optCleaningShort', price: 75 };
const repairService = { id: 'repair_grave', name: 'repairGrave', price: 0, quoteRequired: true };
const textService = { id: 'text_fix', name: 'fixTexts', price: 0, quoteRequired: true };

const Servicios = ({
  show,
  onClose,
  selectedImages,
  onImageSelect,
  onContinue,
  popup,
  tittlepopup,
  displayAlert
}) => {
  const { t } = useTranslation();
  const [hoveredImageId, setHoveredImageId] = useState(null);
  const [focusedImageId, setFocusedImageId] = useState(null);
  const [openSection, setOpenSection] = useState(null);
  const navigate = useNavigate();
  const clickTimer = React.useRef(null);

  if (!show) {
    return null;
  }

  const handleImageClick = (image) => {
    if (clickTimer.current) {
      // Double click detected
      clearTimeout(clickTimer.current);
      clickTimer.current = null;
      onImageSelect(image);
    } else {
      // Possible single click
      clickTimer.current = setTimeout(() => {
        // Single click confirmed
        setFocusedImageId(focusedImageId === image.id ? null : image.id);
        clickTimer.current = null;
      }, 300); // 300ms window for double click
    }
  };

  const COLUMN_COUNT = 3;

  const getHoveredRowIndex = () => {
    if (!hoveredImageId) return null;
    const index = fotos.naturales.findIndex(img => img.id === hoveredImageId);
    if (index === -1) return null;
    return Math.floor(index / COLUMN_COUNT);
  };

  const currentHoveredRowIndex = getHoveredRowIndex();

  const handleSectionToggle = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const handleContinueClick = () => {
    if (onContinue) {
      onContinue();
    } else {
      // Fallback si no se pasa onContinue (aunque debería estar siempre presente)
      if (selectedImages.length > 0) {
        if (popup && tittlepopup) {
          navigate('/confirmacion', {
            state: {
              selectedServiceImage: selectedImages,
              mensajeDePrueba: "Prueba1",
              difuntoInfo: {
                titulo: tittlepopup,
                descripcion: popup
              },
            }
          });
          onClose();
        } else {
          displayAlert(t("selectPersonFirst"));
        }
      } else {
        displayAlert(t("selectAtLeastOne"));
      }
    }
  };

  const isCleaningSelected = selectedImages.some(s => s.id === cleaningService.id);
  const isRepairSelected = selectedImages.some(s => s.id === repairService.id);
  const isTextSelected = selectedImages.some(s => s.id === textService.id);

  return (
    <div className="pannellum-float" onClick={() => setFocusedImageId(null)}>
      <h2>{t('ourServices')}</h2>
      <ul className="services-list">

        <li className={`service-item-accordion ${openSection === 'flores' ? 'open' : ''}`}>
          <div className="accordion-header" onClick={(e) => { e.stopPropagation(); handleSectionToggle('flores'); }}>
            <h3>{t('sectionFlowers')}</h3>
            <p>{t('descFlowers')}</p>
            <span className="toggle-icon">{openSection === 'flores' ? '▲' : '▼'}</span>
          </div>
          <div className="accordion-content" onClick={(e) => { e.stopPropagation(); setFocusedImageId(null); }}>
            {openSection === 'flores' && (
              <div className="image-selection-grid">
                {fotos.naturales.map((image, index) => {
                  const isSelected = selectedImages.some((selected) => selected.id === image.id);
                  const isHovered = hoveredImageId === image.id;
                  const isFocused = focusedImageId === image.id;
                  const isInHoveredRow = currentHoveredRowIndex !== null && Math.floor(index / COLUMN_COUNT) === currentHoveredRowIndex;

                  return (
                    <div
                      key={image.id}
                      className={`image-item ${isSelected ? 'selected' : ''} ${isHovered ? 'hovered' : ''} ${isFocused ? 'focused' : ''} ${isInHoveredRow ? 'in-hovered-row' : ''}`}
                      onClick={(e) => { e.stopPropagation(); handleImageClick(image); }}
                      onMouseEnter={() => setHoveredImageId(image.id)}
                      onMouseLeave={() => setHoveredImageId(null)}
                    >
                      <img src={image.src} alt={image.name} />
                      <div className="item-info">
                        <span className="item-name">{t(image.name)}</span>
                        <span className="item-price">{image.price} €</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </li>

        <li className={`service-item-accordion ${openSection === 'limpieza' ? 'open' : ''}`}>
          <div className="accordion-header" onClick={(e) => { e.stopPropagation(); handleSectionToggle('limpieza'); }}>
            <h3>{t('sectionCleaning')}</h3>
            <p>{t('descCleaning')}</p>
            <span className="toggle-icon">{openSection === 'limpieza' ? '▲' : '▼'}</span>
          </div>
          <div className="accordion-content" onClick={(e) => e.stopPropagation()}>
            {openSection === 'limpieza' && (
              <div className="service-option">
                <div className="checkbox-container" onClick={(e) => { e.stopPropagation(); onImageSelect(cleaningService); }}>
                  <input
                    type="checkbox"
                    checked={isCleaningSelected}
                    readOnly
                  />
                  <label style={{ marginLeft: '10px', cursor: 'pointer' }}>
                    {t('optCleaning')} ({cleaningService.price} €)
                  </label>
                </div>
              </div>
            )}
          </div>
        </li>

        <li className={`service-item-accordion ${openSection === 'asesoramiento' ? 'open' : ''}`}>
          <div className="accordion-header" onClick={(e) => { e.stopPropagation(); handleSectionToggle('asesoramiento'); }}>
            <h3>{t('sectionCustom')}</h3>
            <p>{t('descCustom')}</p>
            <span className="toggle-icon">{openSection === 'asesoramiento' ? '▲' : '▼'}</span>
          </div>
          <div className="accordion-content" onClick={(e) => e.stopPropagation()}>
            {openSection === 'asesoramiento' && (
              <div className="service-option-group">
                <div className="checkbox-container" onClick={(e) => { e.stopPropagation(); onImageSelect(repairService); }}>
                  <input
                    type="checkbox"
                    checked={isRepairSelected}
                    readOnly
                  />
                  <label style={{ marginLeft: '10px', cursor: 'pointer' }}>
                    {t(repairService.name)}
                  </label>
                </div>
                <div className="checkbox-container" onClick={(e) => { e.stopPropagation(); onImageSelect(textService); }}>
                  <input
                    type="checkbox"
                    checked={isTextSelected}
                    readOnly
                  />
                  <label style={{ marginLeft: '10px', cursor: 'pointer' }}>
                    {t(textService.name)}
                  </label>
                </div>
                <div className="service-note" style={{ marginTop: '15px', fontStyle: 'italic', color: '#ffd700', fontSize: '0.9em' }}>
                  {t('customNote')}
                </div>
              </div>
            )}
          </div>
        </li>
      </ul>
      <div className="cart-summary" style={{ textAlign: 'center', marginBottom: '-5px', padding: '10px', backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: '8px', color: '#fff', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {selectedImages.length > 0 ? (
          <span style={{ fontWeight: 'bold', color: '#ffd700' }}>
            🛒 {selectedImages.length} {selectedImages.length === 1 ? t('itemSelected') : t('itemsSelected')}
          </span>
        ) : (
          <span style={{ color: '#aaa', fontStyle: 'italic' }}>🛒 {t('noItemsSelected')}</span>
        )}
        <span style={{ fontSize: '0.82rem', color: '#ffd700', fontStyle: 'italic', opacity: 0.9 }}>
          {t('selectionInstruction')}
        </span>
      </div>

      <div className="services-buttons-group" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="close-services-button">{t('closeButton')}</button>
        <button
          className="continue-button"
          onClick={handleContinueClick}
          disabled={selectedImages.length === 0}
        >
          {t('continueButton')}
        </button>

      </div>
    </div>
  );
};

export default Servicios;